import { ApiProject, ApiSimpleSubscription } from "@incendium/api";
import { listPublicSubscriptions } from "features/subscription/services/subscriptionService";
import { useProjectSharedState } from "Hooks/useSharedState";

const fetchPublicSubscriptions = async (selectedProject: ApiProject | null) => {
  if (!selectedProject?.id) {
    return [];
  }
  const publicSubscriptions = await listPublicSubscriptions(selectedProject.id);
  return publicSubscriptions || [];
};

const usePublicSubscriptions = () => {
  const { state, setState, loading, refetch } = useProjectSharedState<
    ApiSimpleSubscription[]
  >("publicSubscriptions", [], fetchPublicSubscriptions);

  return {
    publicSubscriptions: state,
    setPublicSubscriptions: setState,
    loading,
    refetch,
  };
};
export default usePublicSubscriptions;
